import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
import { submitModuleFeedback } from "../services/moduleFeedback";

/**
 * Primary action styling. The dialog previously coloured "Cancel" as the
 * emphasised button and greyed out "Submit Feedback", which inverted the
 * hierarchy — the button that does the thing should be the one that looks like
 * it does the thing.
 */
export const buttonStyle = {
  background: "var(--brand-600)",
  color: "white",
  borderRadius: "var(--r-md)",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "13px",
  px: 2,
  "&:hover": {
    background: "var(--brand-700)",
  },
};

export const secondaryButtonStyle = {
  background: "var(--surface)",
  color: "var(--ink-2)",
  border: "1px solid var(--border-strong)",
  borderRadius: "var(--r-md)",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "13px",
  px: 2,
  "&:hover": {
    background: "var(--surface-hover)",
  },
};

export const title = {
  fontSize: { xl: "1rem", xs: "1.25rem" },
  fontWeight: 600,
  paddingTop: '10px',
  paddingBottom: '0px'
};

export const contentStyle = {
  fontSize: { xl: "0.8rem", xs: "0.8rem" },
  fontWeight: 400,
  textTransform: "none",
};

export default function ModuleFeedback({
  content,
  handleAgree,
  open,
  show,
  module
}) {
  const [feedback, setFeedback] = React.useState("");
  const [rating, setRating] = React.useState(0);

  React.useEffect(() => {
    if(module) {
      console.log('module____________', module);
    }
  }, [module]);

  const handleClose = () => {
    show(!open);
    handleAgree();
  };

  const handleSubmit = async() => {
    // Handle feedback submission here
    console.log("Feedback:", feedback);
    console.log("Rating:", rating);
    handleAgree();
    const { data } = await submitModuleFeedback(feedback, rating, module?._id);
    console.log('message', data?.message);
  };

  return (
    <React.Fragment >
      <Dialog
        sx={{ borderRadius: 5 }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={title} id="alert-dialog-title">
          {module?.title}
        </DialogTitle>
        <DialogContent sx={{ width: '300px' }}>
          <DialogContentText sx={contentStyle} id="alert-dialog-description">
            {content}
          </DialogContentText>
          {/* Feedback Input */}
          <TextField
            fullWidth
            multiline
            rows={2}
            placeholder="Write your feedback here..."
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            sx={{ marginTop: 2, borderRadius: '20px' }}
          />
          {/* Star Rating */}
          <Stack direction="row" spacing={1} alignItems="center" justifyContent={"center"} sx={{ marginTop: 2 }}>
            {/* <DialogContentText sx={{ fontWeight: 400 }}>Rate:</DialogContentText> */}
            <Rating
              name="feedback-rating"
              sx={{ fontSize: '30px' }}
              value={rating}
              onChange={(event, newValue) => setRating(newValue)}
            />
          </Stack>
        </DialogContent>
        <DialogActions
          sx={{
            borderTop: "1px solid var(--border-subtle)",
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            px: 2.5,
            py: 2,
          }}
        >
          <Button onClick={handleClose} sx={secondaryButtonStyle}>
            Skip
          </Button>
          <Button onClick={handleSubmit} sx={buttonStyle} autoFocus>
            Submit feedback
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
